var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.iframeBase)?_c('div',{staticClass:"w-full"},[_c('cabecera-web'),_c('div',{staticClass:"w-full px-5 mx-auto max-w-screen-xl"},[_c('iframe-viewer',{staticClass:"w-full",attrs:{"iframeSrc":_vm.iframeSrc}})],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }